export const WysiwygShortcuts = {
  Checklist: (metaKey: string) => `(${metaKey} + ⇧ + 9)`,
  Bold: (metaKey: string) => `(${metaKey} + B)`,
  Bulletslist: (metaKey: string) => `(${metaKey} + ⇧ + 8)`,
  Italic: (metaKey: string) => `(${metaKey} + I)`,
  Link: (metaKey: string) => `(${metaKey} + K)`,
  Numberslist: (metaKey: string) => `(${metaKey} + ⇧ + 7)`,
  Redo: (metaKey: string) => `(${metaKey} + ⇧ + Z)`,
  Underline: (metaKey: string) => `(${metaKey} + U)`,
  Undo: (metaKey: string) => `(${metaKey} + Z)`,
};
